// Copilot API client (SPEC 001)
import api from "../axios";
import {
  CopilotConversation,
  CopilotConversationDetail,
  CopilotOnboarding,
  CopilotTurnResponse,
} from "../../interfaces/Copilot";
import {
  GetConversationParams,
  ListConversationsParams,
  SendMessageRequest,
} from "./types";

const BASE = "/Copilot";

export async function getOnboarding(): Promise<CopilotOnboarding> {
  const { data } = await api.get(`${BASE}/onboarding`);
  return data;
}

export async function dismissOnboarding(): Promise<void> {
  await api.post(`${BASE}/onboarding/dismiss`);
}

export async function listConversations(
  params?: ListConversationsParams
): Promise<CopilotConversation[]> {
  const { data } = await api.get(`${BASE}/conversations`, { params });
  return data;
}

export async function createConversation(): Promise<CopilotConversation> {
  const { data } = await api.post(`${BASE}/conversations`);
  return data;
}

export async function getConversation(
  id: string,
  params?: GetConversationParams
): Promise<CopilotConversationDetail> {
  const { data } = await api.get(`${BASE}/conversations/${id}`, { params });
  return data;
}

export async function sendMessage(
  conversationId: string,
  request: SendMessageRequest
): Promise<CopilotTurnResponse> {
  const { data } = await api.post(
    `${BASE}/conversations/${conversationId}/messages`,
    request
  );
  return data;
}

export async function editMessage(
  conversationId: string,
  messageId: string,
  content: string
): Promise<CopilotTurnResponse> {
  const { data } = await api.put(
    `${BASE}/conversations/${conversationId}/messages/${messageId}`,
    { content }
  );
  return data;
}

export async function confirmBatch(
  batchId: string
): Promise<CopilotTurnResponse> {
  const { data } = await api.post(`${BASE}/tool-calls/batch/${batchId}/confirm`);
  return data;
}

export async function cancelBatch(
  batchId: string
): Promise<CopilotTurnResponse> {
  const { data } = await api.post(`${BASE}/tool-calls/batch/${batchId}/cancel`);
  return data;
}

export async function deleteConversation(id: string): Promise<void> {
  await api.delete(`${BASE}/conversations/${id}`);
}

export async function deleteAllConversations(): Promise<void> {
  await api.delete(`${BASE}/conversations`);
}

export interface ReindexRagResult {
  projectsMarked: number;
  timesheetsMarked: number;
}

// Admin-only: flags all Project + TimeSheet rows for RAG re-indexing.
export async function reindexRag(): Promise<ReindexRagResult> {
  const { data } = await api.post(`${BASE}/admin/reindex`);
  return data;
}
